<template>
  <div style="margin-left:10px">
    <vx-card class="mt-3">
      <vs-row vs-w="12" class="mb-3">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-input v-model="mmsi" class="w-full" label-placeholder="MMSI" placeholder="MMSI" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <vs-input v-model="name" class="w-full" label-placeholder="Name" placeholder="Name" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <vs-input v-model="imo" class="w-full" label-placeholder="IMO" placeholder="IMO" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <vs-input
            v-model="CallSign"
            class="w-full"
            label-placeholder="Call sign"
            placeholder="Call sign"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="2" vs-xs="12">
          <v-select
            id="shiptype"
            :options="optionsShipTypes"
            v-model="selectShiptype"
            class="w-full mt-4"
            label="name"
            label-placeholder="MID"
            placeholder="MID"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-3">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12">
          <v-select
            id="shiptype"
            :options="optionsVesselGroup"
            v-model="selectVesselGroup"
            class="w-full"
            label="name"
            label-placeholder="Vessel group"
            placeholder="Vessel group"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="12">
          <v-select
            id="shiptype"
            :options="optionsReportTypes"
            v-model="selectReportType"
            class="w-full"
            label="name"
            label-placeholder="Report type"
            placeholder="Report type"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="formdatetime"
            placeholder="From"
            class="w-full inputDateReport"
          />
          <button class="m-0 p-3 xclose" @click="formdatetime=''">x</button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="todatetime"
            placeholder="To"
            class="w-full inputDateReport"
          />
          <button class="ml-0 p-3 xclose" @click="todatetime=''">x</button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <vs-button
            id="button-with-loading"
            ref="loadableButton"
            class="w-full vs-con-loading__container"
            icon-pack="feather"
            icon="icon-search"
            @click="searchReport(),openLoadingContained()"
          >Search</vs-button>
        </vs-col>
      </vs-row>
      <center>
        <vs-alert
          :active="statusLoading"
          color="primary"
          style="width:30%"
          title="Loading...."
        >กำลังโหลดข้อมูลรายงาน กรุณารอสักครู่...</vs-alert>
      </center>
      <br />
      <vs-table
        ref="reportTable"
        :sst="true"
        :data="reports"
        v-model="selected"
        pagination
        max-items="10"
      >
        <template slot="thead">
          <vs-th sort-key="id">No.</vs-th>
          <vs-th sort-key="mmsi">MMSI</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="record_time">Recode time</vs-th>
          <vs-th sort-key="call_sign">Call sign</vs-th>
          <vs-th sort-key="imo_number">Imo number</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
              <vs-td :data="data[indextr].id">{{ tr.index+1 }}</vs-td>
              <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
              <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
              <vs-td :data="data[indextr].record_time">{{ data[indextr].record_time }}</vs-td>
              <vs-td :data="data[indextr].call_sign">{{ data[indextr].call_sign }}</vs-td>
              <vs-td :data="data[indextr].imo_number">{{ data[indextr].imo_number }}</vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import {
  API_GET_SHIP_TYPE,
  API_ADMIN_VESSEL_GROUP,
  API_VESSEL_REPORT
} from "@/constants/api";
import { API_BASE_URL } from '@/constants'

export default {
  components: {
    flatPickr,
    "v-select": vSelect
  },
  data() {
    return {
      statusLoading: false,
      selectReportType: {},
      selectShiptype: {
        id: 81,
        to_s: "80 Tanker, all ships of this type",
        code: "80",
        name: "Tanker, all ",
        url: `${API_BASE_URL}/admin/ship_types/81.json`
      },
      selectVesselGroup: null,
      shipTypes: [],
      optionsShipTypes: [],
      optionsVesselGroup: [],
      optionsReportTypes: [
        { id: 1, name: "AIS" },
        { id: 2, name: "SAT" },
        { id: 3, name: "VMS" }
      ],
      selected: {},
      formdatetime: "",
      todatetime: "",
      mmsi: "",
      name: "",
      CallSign: "",
      imo: "",
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d/m/Y H:i"
      },
      reports: [],
      accessEmail: "",
      accessToken: ""
    };
  },
  watch: {
    reports() {
      for (let i = 0; i < this.reports.length; i++) {
        this.reports[i].index = i;
      }
    },
    selected(val) {
      localStorage.setItem("detailReport", JSON.stringify(val.url));
      localStorage.setItem(
        "reportShiptype",
        JSON.stringify(this.selectShiptype.id)
      );
      localStorage.setItem("reportFromDate", JSON.stringify(this.formdatetime));
      localStorage.setItem("reportToDate", JSON.stringify(this.todatetime));
      let routeData = this.$router.resolve({ name: "DetailReport" });
      window.open(routeData.href, "_blank");
    }
  },

  mounted() {
    this.openLoadingContained();
    this.getdate();
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "Reports");
    this.shipTypes = this.$store.state.shipTypes;
    this.getDataReport();
    const url = API_GET_SHIP_TYPE();
    axios
      .get(url, {
        params: {
          limit: 100
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.optionsShipTypes = response.data;
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
    const url2 = API_ADMIN_VESSEL_GROUP();
    axios
      .get(url2, {
        params: {
          limit: 10
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.optionsVesselGroup = response.data;
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  methods: {
    closeLoadingData() {
      this.statusLoading = false;
      this.$vs.notify({
        time: "3000",
        title: "Success",
        text: "โหลดข้อมูลรายงาน เรียบร้อย",
        color: "success",
        position: "top-center",
        fixed: false
      });
    },
    closeLoadingDataNull() {
      this.statusLoading = false;
      this.$vs.notify({
        time: "3000",
        title: "warning",
        text: "ไม่พบข้อมูลที่ค้นหา",
        color: "warning",
        position: "top-center",
        fixed: false
      });
    },
    openLoadingData() {
      this.statusLoading = true;
    },
    openLoadingContained() {
      this.statusLoading = true;
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      });
    },
    getDataReport() {
      this.openLoadingData();
      this.openLoadingContained();
      const url = API_VESSEL_REPORT();
      axios
        .get(url, {
          params: {
            limit: 100
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.reports = response.data;
          setTimeout(() => {
            // sort table
            const key = "record_time";
            const sortType = "asc";
            this.$refs.reportTable.sort(key, sortType);
          }, 100);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.closeLoadingData();
        })
        .catch(error => {
          this.statusLoading = false;
          this.$vs.notify({
            time: "3000",
            title: "Error",
            text: error,
            color: "danger",
            position: "top-center",
            fixed: false
          });
        });
    },
    getdate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let formtime =
        String(parseInt(dd - 1)) + "/" + mm + "/" + yyyy + " " + "00:00";
      let totime =
        dd +
        "/" +
        mm +
        "/" +
        yyyy +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();
      this.formdatetime = formtime;
      this.todatetime = totime;
    },
    searchReport() {
      this.openLoadingData();
      console.log("this.selectVesselGroup", this.selectVesselGroup);
      this.openLoadingContained();
      if (this.selectShiptype == null || this.selectShiptype == {}) {
        this.selectShiptype = {
          id: ""
        };
      } else if (this.selectReportType == null || this.selectReportType == {}) {
        this.selectReportType = {
          name: ""
        };
      } else if (
        this.selectVesselGroup == null ||
        this.selectVesselGroup == {}
      ) {
        this.selectVesselGroup = {
          id: ""
        };
      }

      if (this.selectVesselGroup.id == "") {
        const url = API_VESSEL_REPORT();
        axios
          .get(url, {
            params: {
              utf8: "✓",
              "q[mmsi_cont]": this.mmsi,
              "q[imo_number_cont]": this.imo,
              "q[call_sign_cont]": this.CallSign,
              "q[name_cont]": this.name,
              "q[ship_type_id_eq]": this.selectShiptype.id,
              "q[vessel_groups_id_eq]": this.selectVesselGroup.id,
              "q[position_reports_report_type_eq]": this.selectReportType.name,
              "q[position_reports_ais_source_id_eq]": "",
              record_time_gteq: this.formdatetime,
              record_time_lteq: this.todatetime,
              limit: 100
            },
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          })
          .then(response => {
            this.reports = response.data;
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            if (this.reports.length > 0) {
              this.closeLoadingData();
            } else {
              this.closeLoadingDataNull();
            }
          })
          .catch(error => {
            console.log("Error call apis :", error);
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            this.statusLoading = false;
            this.$vs.notify({
              time: "3000",
              title: "Error",
              text: error,
              color: "danger",
              position: "top-center",
              fixed: false
            });
          });
      } else {
        this.dataLoading = true;
        console.log("no limit");
        axios
          .get(`${API_BASE_URL}/vessel_reports.json`, {
            params: {
              utf8: "✓",
              "q[mmsi_cont]": this.mmsi,
              "q[imo_number_cont]": this.imo,
              "q[call_sign_cont]": this.CallSign,
              "q[name_cont]": this.name,
              "q[ship_type_id_eq]": this.selectShiptype.id,
              "q[vessel_groups_id_eq]": this.selectVesselGroup.id,
              "q[position_reports_report_type_eq]": this.selectReportType.name,
              "q[position_reports_ais_source_id_eq]": "",
              record_time_gteq: this.formdatetime,
              record_time_lteq: this.todatetime
            },
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          })
          .then(response => {
            this.reports = response.data;
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            this.closeLoadingData();
          })
          .catch(error => {
            console.log("Error call apis :", error);
            this.statusLoading = false;
            this.$vs.notify({
              time: "3000",
              title: "Error",
              text: error,
              color: "danger",
              position: "top-center",
              fixed: false
            });
          });
      }
    }
  }
};
</script>
<style>
.selectbox {
  max-width: 30em;
  margin: 1em auto;
}
.inputDateReport {
  height: 36px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 10px;
}
.xclose {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
        
    

